import React, { useState } from "react";
import { Reveal, Overline } from "./Reveal";
import { GALLERY } from "@/data/content";
import { X } from "lucide-react";

export function Gallery() {
  const [active, setActive] = useState(null);

  return (
    <section id="gallery" data-testid="gallery-section" className="py-24 md:py-32 bg-epic-charcoal border-y border-white/5">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12">
        <Reveal className="mb-12">
          <Overline>The Gallery</Overline>
          <h2 className="font-display text-4xl md:text-6xl text-white leading-none mt-4">Moments At The Epic</h2>
        </Reveal>

        <div className="masonry">
          {GALLERY.map((src, i) => (
            <button
              key={src}
              data-testid={`gallery-item-${i}`}
              onClick={() => setActive(src)}
              className="group block w-full overflow-hidden"
            >
              <img
                src={src}
                alt={`Gallery ${i + 1}`}
                className="w-full object-cover transition-transform duration-700 group-hover:scale-105"
              />
            </button>
          ))}
        </div>
      </div>

      {active && (
        <div
          data-testid="gallery-lightbox"
          onClick={() => setActive(null)}
          className="fixed inset-0 z-[60] bg-epic-black/95 backdrop-blur-md flex items-center justify-center p-6"
        >
          <button data-testid="lightbox-close" className="absolute top-6 right-6 text-white hover:text-epic-gold">
            <X size={32} />
          </button>
          <img src={active} alt="Enlarged" className="max-h-[85vh] max-w-full object-contain" />
        </div>
      )}
    </section>
  );
}
